import { CLEAR_ORDERS, GET_ORDERS } from 'modules/dashboard/store/constants';

export const clearOrders = () => ({
  type: CLEAR_ORDERS,
});

export const getOrders = () => ({
  type: GET_ORDERS,
});
